/* RESPONSIBLE TEAM: team-proactive-support */
import { EmbeddedRecordsMixin } from '@ember-data/serializer/rest';
import EmbercomBaseSerializer from 'embercom/serializers/base/embercom-base-serializer';

export default class NewsItemSerializer extends EmbercomBaseSerializer.extend(
  EmbeddedRecordsMixin,
) {
  attrs = {
    localizedNewsItemContents: { embedded: 'always' },
    newsfeedIds: { embedded: 'always' },
    labelIds: { embedded: 'always' },
  };
}
